import {InitialRequestParams} from "../../../core/models/initial-request-params";
import {ResourceRequestParams} from "./resource-request-params";
import {BaseFetchModel} from "../base-fetch-model";
import {TIME_GAP_REQUEST_MS} from "../../../core/consts";

export class BaseApiRequestParams extends ResourceRequestParams {
  initialParams: InitialRequestParams;
  lastUpdateId: Number = null;
  requestedUpdateId: Number = null;
  fetchModel: BaseFetchModel = null;
  usePrefix: Boolean;

  constructor(route: String, fetchModel: BaseFetchModel = null) {
    super(route);

    this.requestedUpdateId = -1;
    this.fetchModel = fetchModel || null;
    this.usePrefix = true;
    this.lastUpdateId = null;
    this.timeStamp = null
  }

  get lastUpdateIdParam() {
    return (this.lastUpdateId ? `&lastUpdateId=${this.lastUpdateId}` : '');
  }

  toString() {
    return super.toString() + (this.initialParams ? '?' + this.initialParams.toString() : '');
  }

  get fullUrl(): String {
    const url: String = this.toString() + this.lastUpdateIdParam;

    return url;
  }

  get queryParams() {
    return '';
  }

  equals(model: BaseApiRequestParams): Boolean {
    let equals = this.initialParams?.toString() === model.initialParams?.toString();

    equals &= this.baseUrl === model.baseUrl;

    return equals;
  }

  get timeGap(): Number {
    return TIME_GAP_REQUEST_MS.default
  }
}
